// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardPageContent_container__xbFdO","header-container":"DashboardPageContent_header-container__ycn_A"};